export default "__VITE_ASSET__DcewuaNm__"